import { connect } from "react-redux";
import { ApplicationState } from "store";
import { actionCreators, getCalendar } from "page/calendar/store";
import CalendarFramePicker from "./calendar-frame-picker";
import { actionCreators as uiActionCreators } from "ui/store";
import {
    getBorderOptions,
    actionCreators as burdeContentActionCreators,
} from "burde-api-content/store";

const mapStateToProps = (state: ApplicationState) => ({
    calendar: getCalendar(state),
    borderOptions: getBorderOptions(state),
});

const mapDispatchToProps = {
    ...actionCreators,
    ...uiActionCreators,
    ...burdeContentActionCreators,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CalendarFramePicker);
